import React from "react";
import { Asset, TourData } from "../../../Types";
import { UseDownloadAsset, useDeleteAsset } from "../../../api/calls/Queries";
import { Pause, Play } from "../../Icons/Player";
import AudioIconFile from "../../Icons/AudioFileIcon";
import { getLanguageFile } from "../../common/GetLanguageFile";

const AssetPreview = (props: {
  tourData: TourData;
  selectedAsset: number | undefined;
  assets: Asset[];
  assetListOpenType: 1 | 2 | 3 | undefined;
}) => {
  const { tourData, selectedAsset, assets, assetListOpenType } = props;

  const currentAsset = React.useMemo(() => {
    const sel = assets.find((one) => one.assetId === selectedAsset);
    return sel;
  }, [assets, selectedAsset]);

  const { data: preview, isLoading } = UseDownloadAsset(
    currentAsset?.assetKeyThumb || currentAsset?.assetKeyLow
  );

  const missingUsedAssetsList = React.useMemo(() => {
    return !tourData.usedAssets || !tourData.usedPanos;
  }, [tourData.usedAssets, tourData.usedPanos]);

  const isUsed: boolean = React.useMemo(() => {
    if (assetListOpenType === 1) {
      return !!tourData.usedPanos?.find((one) => one === currentAsset?.assetId);
    } else return true;
  }, [tourData.usedPanos, assetListOpenType, currentAsset?.assetId]);

  const {
    mutateAsync: deleteAsset,
    isPending: isDeleting,
    isError,
  } = useDeleteAsset(assetListOpenType!);

  return (
    <div style={previewStyle}>
      {currentAsset && (
        <>
          {assetListOpenType !== 3 && (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                background: "#2222",
              }}
            >
              <img
                src={preview}
                alt="Thumbnail mancante"
                style={{
                  maxWidth: "250px",
                  maxHeight: "250px",
                }}
              />
            </div>
          )}
          {assetListOpenType === 3 && (
            <AudioPreview asset={currentAsset}></AudioPreview>
          )}

          <br />
          <div>
            <span style={labelStyle}>
              {getLanguageFile("overlapping_panel.name")}{" "}
            </span>
            <span style={descStyle}>{currentAsset.assetDescription}</span>
            <br></br>
            <span style={labelStyle}>
              {getLanguageFile("overlapping_panel.size")}{" "}
            </span>
            <span style={descStyle}>{currentAsset.assetSize} MB</span>

            <br />

            <hr></hr>
            {assetListOpenType !== 3 && (
              <>
                <span style={descStyle}>
                  {getLanguageFile("overlapping_panel.full_res")}{" "}
                  <b>{!!currentAsset.assetKeyFull ? "✓" : "✗"}</b>
                </span>
                <br></br>

                <span style={descStyle}>
                  {assetListOpenType === 1
                    ? getLanguageFile("overlapping_panel.lo_res")
                    : getLanguageFile("overlapping_panel.thumb")}{" "}
                  <b>{!!currentAsset.assetKeyLow ? "✓" : "✗"}</b>
                </span>

                {assetListOpenType === 1 && (
                  <>
                    <br></br>
                    <span style={descStyle}>
                      {getLanguageFile("overlapping_panel.thumb")}{" "}
                      <b>{!!currentAsset.assetKeyThumb ? "✓" : "✗"}</b>
                    </span>
                    <br></br>
                  </>
                )}
              </>
            )}
            {/* NEEDS IMPROVEMENTS */}
            {/* <hr></hr>
            <span>
              {!missingUsedAssetsList && isUsed ? "usata" : "non usata"}
            </span>
            <button
              id="delete"
              style={{ color: "#222" }}
              disabled={isUsed || isDeleting}
              onClick={() => deleteAsset(currentAsset.assetId)}
            >
              Elimina <Trashbin></Trashbin>
            </button> */}
          </div>
        </>
      )}
    </div>
  );
};

export default AssetPreview;

const AudioPreview = (props: { asset: Asset }) => {
  const { asset } = props;

  const audioRef = React.useRef(new Audio());
  const { data: preview, isLoading } = UseDownloadAsset(asset?.assetKeyFull);

  React.useEffect(() => {
    if (preview) {
      audioRef.current.src = preview;
      audioRef.current.onloadeddata = (e) => e.preventDefault();
    }
  }, [preview]);

  const playButtonAction = () => {
    if (audioRef.current.paused) {
      audioRef.current.play();
    } else audioRef.current.pause();
  };

  const [playing, setPlaying] = React.useState<boolean>(false);

  return (
    <>
      <div
        style={{
          background: "#4448",
          width: 100,
          height: 100,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <AudioIconFile stroke="white" width={50} height={50}></AudioIconFile>
      </div>
      {isLoading && getLanguageFile("generics.loading")}

      <label style={{ display: "flex", alignItems: "center", gap: 2 }}>
        <button className="play-button" onClick={() => playButtonAction()}>
          {!playing ? (
            <Play width={20} height={20}></Play>
          ) : (
            <Pause width={20} height={20}></Pause>
          )}
        </button>
        {getLanguageFile("overlapping_panel.play_preview")}
      </label>

      {/* {asset.assetKeyFu§ll} */}

      {/* {audioRef.current.currentTime} */}
      <audio
        ref={audioRef}
        onPlaying={(e) => {
          return;
        }}
        onPlay={(e) => {
          setPlaying(true);
          return e.preventDefault();
        }}
        onPause={(e) => {
          setPlaying(false);
          return e.preventDefault();
        }}
        onEnded={() => setPlaying(false)}
        onTimeUpdate={(e) => {
          const elapsedTime = e.currentTarget.currentTime;

          if (elapsedTime > 10) {
            e.currentTarget.pause();
            e.currentTarget.currentTime = 0;
          }
          return e.preventDefault();
        }}
      ></audio>
      <br />
    </>
  );
};

const previewStyle: React.CSSProperties = {
  background: "#2222",
  width: "100%",

  boxSizing: "border-box",

  padding: 10,
};

const labelStyle: React.CSSProperties = { fontWeight: 600 };
const descStyle: React.CSSProperties = {
  fontWeight: 400,
  fontSize: "0.95rem",
  wordWrap: "break-word",
};
